import SwitchCompany from 'pages/switchcompany';

export const LoginRoutes = [
  {
    path: '/login',
    lazy: () => import('pages/login'),
  },
  { path: '/switchcompany', element: <SwitchCompany /> },
  {
    path: '/supplier/signup',
    async lazy() {
      const { Signup } = await import('pages/supplier');
      return { Component: Signup };
    },
  },
  {
    path: '/supplier/verify',
    async lazy() {
      const { Verify } = await import('pages/supplier');
      return { Component: Verify };
    },
  },
];
